/**
 * TODO: mention what to use instead or consider to delete this object
 *
 * @deprecated
 */export default{DOWN:40,UP:38,LEFT:37,RIGHT:39,ENTER:13,ESCAPE:27,TAB:9,SPACE:32,BACKSPACE:8,DELETE:46,COMMA:188,PERIOD:190};